import React from 'react';
import PropTypes from 'prop-types';
import { DetailsLayout, Text } from '../../common';

function DiagnosisDetails({
  displayName,
  icd10Code,
  treatingDoctor,
  isSearchResult,
  notes,
}) {
  return (
    <DetailsLayout heading={displayName}>
      {isSearchResult && icd10Code && <Text>{icd10Code.code}</Text>}
      {treatingDoctor && (treatingDoctor.firstName || treatingDoctor.lastName) && (
        <Text>
          Treating Doctor: {treatingDoctor && treatingDoctor.firstName}{' '}
          {treatingDoctor && treatingDoctor.lastName}
        </Text>
      )}
      {notes && (
        <div>
          <Text>Notes: </Text>
          <Text>{notes}</Text>
        </div>
      )}
    </DetailsLayout>
  );
}

DiagnosisDetails.propTypes = {
  displayName: PropTypes.string.isRequired,
  isSearchResult: PropTypes.bool.isRequired,
  icd10Code: PropTypes.shape({
    description: PropTypes.string.isRequired,
    code: PropTypes.string,
  }),
  notes: PropTypes.string,
  treatingDoctor: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
};

export default DiagnosisDetails;



// WEBPACK FOOTER //
// ./src/modules/DiagnosisPage/components/DiagnosisDetails.js